module.exports = __webpack_public_path__ + "media/images/CO2simple-db50ba88a82c7164d49681cd8b424100.svg";